import type { CSSProperties } from 'react';

import cn from 'classnames';

import styles from './Eyebrow.module.scss';

import type { EyebrowProps } from './Eyebrow.types';

export const Eyebrow = ({ label, icon, dot = true, pill = true, color, background, className }: EyebrowProps) => {
  const style = {
    '--eyebrow-color': color,
    '--eyebrow-bg': background,
  } as CSSProperties;

  return (
    <span className={cn(styles.eyebrow, pill && styles.eyebrow_pill, className)} style={style}>
      {icon ? <span className={styles.icon}>{icon}</span> : dot && <span className={styles.dot} />}

      {label}
    </span>
  );
};
